import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LoadingService } from './core/services/loading.service';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  private idiomaFinal: string = 'pt';

  title = 'GBP.Web';
  loading$ = this.loadingService.loading$;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private translate: TranslateService, 
    private loadingService: LoadingService
  ) {
    translate.addLangs(['en', 'pt', 'es']);
    translate.setDefaultLang('pt');

    const queryParamsString = window.location.search || window.location.hash.split('?')[1] || '';
    const urlParams = new URLSearchParams(queryParamsString);
    const idiomaUrl = urlParams.get('lang');

    const idiomaSalvo = localStorage.getItem('idioma_preferido');

    if (idiomaUrl && ['pt', 'en', 'es'].includes(idiomaUrl)) {
      this.idiomaFinal = idiomaUrl;
    } else if (idiomaSalvo && ['pt', 'en', 'es'].includes(idiomaSalvo)) {
      this.idiomaFinal = idiomaSalvo;
    } else {
      this.idiomaFinal = 'pt';
    }

    localStorage.setItem('idioma_preferido', this.idiomaFinal);
    this.translate.use(this.idiomaFinal);
  }

  ngOnInit() {
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event: any) => {
      
      const urlTree = this.router.parseUrl(event.urlAfterRedirects);
      const langInUrl = urlTree.queryParams['lang'];
      const langInCache = localStorage.getItem('idioma_preferido') || 'pt';

      if (langInUrl && ['pt', 'en', 'es'].includes(langInUrl) && langInUrl !== langInCache) {
        localStorage.setItem('idioma_preferido', langInUrl);
        this.translate.use(langInUrl);
        this.idiomaFinal = langInUrl;
      } 
      else if (langInUrl !== langInCache) {
        urlTree.queryParams['lang'] = langInCache;
        this.router.navigateByUrl(urlTree, { replaceUrl: true });
      }
    });
  }
}
